export const CHAT_SCROLL_BOTTOM_THRESHOLD_PX = 72;

export interface ChatScrollMetrics {
  scrollHeight: number;
  scrollTop: number;
  clientHeight: number;
}

export interface ChatScrollIntent {
  isFollowingBottom: boolean;
  isUserDetached: boolean;
  showScrollToBottom: boolean;
}

export function createChatScrollIntent(): ChatScrollIntent {
  return {
    isFollowingBottom: false,
    isUserDetached: false,
    showScrollToBottom: false,
  };
}

export function getDistanceFromBottom(metrics: ChatScrollMetrics): number {
  return Math.max(0, metrics.scrollHeight - metrics.scrollTop - metrics.clientHeight);
}

export function isNearBottom(
  metrics: ChatScrollMetrics,
  thresholdPx: number = CHAT_SCROLL_BOTTOM_THRESHOLD_PX,
): boolean {
  return getDistanceFromBottom(metrics) <= thresholdPx;
}

export function requestBottomFollow(intent: ChatScrollIntent): ChatScrollIntent {
  return {
    ...intent,
    isFollowingBottom: true,
    isUserDetached: false,
    showScrollToBottom: false,
  };
}

export function stopBottomFollow(intent: ChatScrollIntent): ChatScrollIntent {
  return {
    ...intent,
    isFollowingBottom: false,
  };
}

export function applyViewportScroll(
  intent: ChatScrollIntent,
  metrics: ChatScrollMetrics,
  thresholdPx: number = CHAT_SCROLL_BOTTOM_THRESHOLD_PX,
): ChatScrollIntent {
  if (isNearBottom(metrics, thresholdPx)) {
    return requestBottomFollow(intent);
  }

  return {
    ...intent,
    isFollowingBottom: false,
    isUserDetached: true,
    showScrollToBottom: true,
  };
}

export function shouldFollowContentGrowth(intent: ChatScrollIntent): boolean {
  return intent.isFollowingBottom && !intent.isUserDetached;
}
